<template>
  <div class="uk-container" >
    <div class="uk-grid-small uk-width-3-4" uk-grid>
        <div class="uk-width-1-1 uk-width-1-2@m uk-flex uk-flex-middle"><h2>Modifier votre mot de passe</h2></div>
    </div>

    <div v-if="success" class="uk-width-1-1 uk-width-3-4@m">
      <div class="uk-margin uk-alert-success" uk-alert>{{success}}</div>
      <button class="uk-button cta-sfr-primary" @click="seConnecter()">Me connecter</button>
    </div>

    <form v-if="!success" method="post" action="#" class="uk-form-stacked uk-flex uk-flex-top uk-width-1-1 uk-width-3-4@m uk-grid-small" uk-grid @submit.prevent="changeMDP()">
        <div class="uk-margin uk-width-1-1 uk-width-1-2@m">
            <label class="uk-form-label" for="form-stacked-text">Nouveau Mot de passe*</label>
            <div class="uk-form-controls">
                <input class="uk-input uk-width-1-1" v-model="input.password" name="password" id="form-stacked-text" type="password" placeholder="Votre mot de passe">
                <span class="error-message">{{error.password}}</span>
            </div>
        </div>
        <div class="uk-margin uk-width-1-1 uk-width-1-2@m">
            <label class="uk-form-label" for="form-stacked-confirm_password">Confirmer votre mot de passe*</label>
            <div class="uk-form-controls">
                <input class="uk-input uk-width-1-1" v-model="input.confirm_password" name="confirm_password" id="form-stacked-confirm_password" type="password" placeholder="Votre mot de passe">
                <span class="error-message">{{error.confirm_password}}</span>
            </div>
        </div>
        <div class="uk-margin uk-width-1-1">
          <p class="gr-texte-black">Votre mot de passe doit contenir au moins 8 caractères.</p>
        </div>
        <div class="uk-margin uk-width-1-1">
          <div v-if="errors" class="uk-margin uk-alert-danger" uk-alert>
             <a class="uk-alert-close" uk-close></a>
            {{errors}}
          </div>
        </div>
    </form>
    <div v-if="!success" class="uk-grid-small uk-width-3-4" uk-grid>
      <div class="uk-flex uk-flex-right uk-width-1-1 uk-margin-large">
          <button class="uk-button cta-sfr-primary" :disabled="loading" @click="changeMDP()">{{ loading ? 'Enregistrement...' : 'VALIDER' }}</button>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios';
import UIkit from 'uikit';
export default {
  name: 'ModificationMdpView',
  components: {
  },
  data() {
      return {
          input: {
            password:"",
            confirm_password:""
          },
          errors:null,
          success:null,
          loading:false,
          error:{
            password:null,
            confirm_password:null
          }
      }
  },

  methods:{
    seConnecter(){
      this.$store.commit('gotoForgot',{forgotform:false});
      this.$router.push('/');
      this.$nextTick(() => {
        const el = document.getElementById('panel-infos');
        if(el){ UIkit.offcanvas(el).show(); }
      });
    },
    changeMDP(){
      this.errors = null;
      this.error.password = null;
      this.error.confirm_password = null;

      if(this.input.password == "" || this.input.confirm_password == ""){
        this.errors = "Vous devez renseigner tous les champs";
        return;
      }
      if(this.input.password.length < 8){
        this.error.password = "Votre mot de passe doit contenir au moins 8 caractères.";
        return;
      }
      if(this.input.password !== this.input.confirm_password){
        this.error.confirm_password = "Les deux mots de passe ne sont pas identiques.";
        return;
      }

      this.loading = true;
      axios.post(this.$store.state.urlws+'changeMDP',
        {
          password:this.input.password,
          confirm_password:this.input.confirm_password,
          codeid:this.$route.params.codeid
        }
      )
      .then(response => {
        this.success = "Votre mot de passe a bien été modifié. Vous pouvez maintenant vous connecter.";
        this.input.password="";
        this.input.confirm_password="";
        this.loading = false;
      })
      .catch(e => {
        const errs = (e.response && e.response.data && e.response.data.messages) ? e.response.data.messages.errors : null;
        if(errs){
          this.error.password = errs.password || null;
          this.error.confirm_password = errs.confirm_password || null;
          if(errs.codeid){ this.errors = errs.codeid; }
        }
        if(!this.error.password && !this.error.confirm_password && !this.errors){
          this.errors = "La modification a échoué. Ce lien est peut-être expiré ou déjà utilisé.";
        }
        this.loading = false;
      })
    },
  },
}
</script>
